// 「問い合わせカテゴリ」のその他を選択した時のテキストエリア(企業向け)
export function displayCategoryTextarea() {
  const askCategory = document.getElementById('js-company-ask-category') as HTMLSelectElement
  const askTextarea = document.getElementById('js-company-ask-textarea') as HTMLTextAreaElement
  if (askCategory === null || askTextarea === null) return

  askTextarea.style.marginTop = '10px'
  askCategory.addEventListener('change', (e) => {
    const display = (e.currentTarget as HTMLSelectElement).value === '3'
    askTextarea.style.display = display ? 'block' : 'none'
    askTextarea.required = display
  })
}
